export default __webpack_public_path__ + "static/media/p-avsar.67db3eaf.jpg";